module.exports = function({ addUtilities, theme }) {
  function getWidth(columns, totalColumns = 8) {
    const gap = theme('spacing.xxs');
    const total = totalColumns == 12 ? theme('screens.xl') : '100vw';

    return `calc((${total} - ${gap}) / ${totalColumns} * ${columns} - ${gap})`;
  }

  function getContainerWidth(columns, totalColumns = 8) {
    const gap = theme('spacing.xxs');
    const total = totalColumns == 12 ? theme('screens.xl') : '100vw';

    return `calc((${total} - ${gap}) / ${totalColumns} * ${columns} + ${gap})`;
  }

  addUtilities(
    {
      '.overflow-clip': {
        overflow: 'clip',
      },
      '.overflow-x-clip': {
        'overflow-x': 'clip',
      },
      '.overflow-y-clip': {
        'overflow-y': 'clip',
      },
      // Columnas sin gaps exteriores
      '.col-3-8': {
        width: getWidth(3),
      },
      '.col-3-12': {
        width: getWidth(3, 12),
      },
      '.col-4-8': {
        width: getWidth(4),
      },
      '.col-4-12': {
        width: getWidth(4, 12),
      },
      '.col-6-8': {
        width: getWidth(6),
      },
      '.col-5-12': {
        width: getWidth(5, 12),
      },
      '.col-6-12': {
        width: getWidth(6, 12),
      },
      '.col-8': {
        width: getWidth(8, 12),
      },
      '.col-10': {
        width: getWidth(10, 12),
      },
      '.container': {
        width: '100%',
        'padding-right': theme('spacing.xxxs'),
        'padding-left': theme('spacing.xxxs'),
        margin: 'auto',

        [`@media (min-width: ${theme('screens.sm')})`]: {
          'padding-right': theme('spacing.xxs'),
          'padding-left': theme('spacing.xxs'),

          '&-thinner': {
            width: getContainerWidth(4),
          },
          '&-thin': {
            width: getContainerWidth(6),
          },
        },

        [`@media (min-width: ${theme('screens.lg')})`]: {
          '&-thinner': {
            width: '100%',
          },
          '&-thin': {
            width: '100%',
          },
        },

        [`@media (min-width: ${theme('screens.xl')})`]: {
          'max-width': theme('screens.xl'),

          '&-thinner': {
            width: getContainerWidth(10, 12),
          },
          '&-thin': {
            width: getContainerWidth(8, 12),
          },
          '&-medium': {
            width: getContainerWidth(10, 12),
          },
        },

        [`@media (min-width: ${theme('screens.2xl')})`]: {
          '&-thin': {
            width: '100%',
          },
        },

        // Columnas con gaps exteriores
        '&-col-4': {
          width: getContainerWidth(4),
        },
        '&-col-6': {
          width: getContainerWidth(6),
        },
        '&-col-8': {
          width: getContainerWidth(8, 12),
        },
        '&-col-10': {
          width: getContainerWidth(10, 12),
        },
      },
    },
    ['responsive']
  );
};
